import { Button, Modal } from 'antd';
import React, { useEffect, useState } from 'react';

import { onApiLimitExceeded } from '../context/ApiLimitContext';

interface ApiLimitModalProps {
    visible: boolean;
    onClose: () => void;
}

export const ApiLimitModal: React.FC<ApiLimitModalProps> = ({ visible, onClose }) => {
    const handleGoHome = () => {
        onClose();
        window.location.href = '/';
    };

    return (
        <Modal open={visible} footer={null} onCancel={onClose} closable={true} centered width={500}>
            <div style={{ textAlign: 'center', padding: '10px 0' }}>
                <div style={{ fontSize: '48px', marginBottom: '16px' }}>😢</div>
                <h2 style={{ marginBottom: '16px', color: '#cf1322' }}>Vyčerpán limit kreditů</h2>
                <p style={{ fontSize: '15px', color: '#595959', marginBottom: '20px', lineHeight: '1.6' }}>
                    Bohužel byly vyčerpány sdílené kredity pro Mapy.cz API na tento měsíc.
                    <br />
                    Hra momentálně nepojede.
                </p>
                <Button type="primary" size="large" onClick={handleGoHome}>
                    Přejít na domovskou stránku
                </Button>
            </div>
        </Modal>
    );
};

/**
 * Wrapper komponenta, která naslouchá na globální eventy a zobrazuje modal
 */
export const ApiLimitModalListener: React.FC = () => {
    const [visible, setVisible] = useState(false);

    useEffect(() => {
        const unsubscribe = onApiLimitExceeded(() => {
            setVisible(true);
        });
        return unsubscribe;
    }, []);

    return <ApiLimitModal visible={visible} onClose={() => setVisible(false)} />;
};

export default ApiLimitModal;
